import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import client, { formatApiError } from "@/lib/api";

const Opt = ({ active, disabled, onClick, children, testid }) => (
  <button type="button" onClick={onClick} disabled={disabled || active}
    className={`px-4 min-h-[40px] rounded-full text-xs font-bold uppercase tracking-wider transition-colors ${active ? "bg-emerald-700 text-white" : "bg-white text-slate-600 border border-slate-200 hover:border-emerald-400"} disabled:cursor-not-allowed ${disabled && !active ? "opacity-50" : ""}`}
    data-testid={testid}>{children}</button>
);

export default function AdminAdModeSwitch() {
  const [m, setM] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { client.get("/admin/ads/mode").then((r) => setM(r.data)).catch(() => setM(null)); }, []);
  if (!m) return null;
  const change = async (mode) => {
    const msg = mode === "paid" ? "PAID mode: new ads will need payment before going live. Continue?" : "FREE mode: new ads go live instantly without payment. Continue?";
    if (!window.confirm(msg)) return;
    setBusy(true);
    try { setM((await client.put("/admin/ads/mode", { mode })).data); toast.success(`Ads mode set to ${mode.toUpperCase()} — existing ads unchanged`); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="border border-slate-100 rounded-2xl p-4 mb-3 bg-white" data-testid="admin-ad-mode">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="min-w-0">
          <div className="font-semibold text-slate-900 text-sm">Ads mode (global)</div>
          <div className="text-xs text-slate-500 mt-0.5" data-testid="admin-ad-mode-help">
            {m.mode === "free" ? "FREE — vendor ads go live instantly, only in the PIN codes they select." : "PAID — ads go live automatically after successful payment, only in the selected PIN codes."}
          </div>
        </div>
        <div className="flex items-center gap-2">
          {busy && <Loader2 className="w-4 h-4 animate-spin text-slate-400" />}
          <Opt active={m.mode === "free"} disabled={m.locked || busy} onClick={() => change("free")} testid="admin-ad-mode-free">Free</Opt>
          <Opt active={m.mode === "paid"} disabled={m.locked || busy} onClick={() => change("paid")} testid="admin-ad-mode-paid">Paid</Opt>
        </div>
      </div>
      {m.locked && (
        <div className="mt-2 flex items-center gap-1.5 text-[11px] text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-2 py-1.5" data-testid="admin-ad-mode-locked">
          <Lock className="w-3 h-3" /> Preview testing: ads are always FREE here. This switch works on the Live site.
        </div>
      )}
      {m.mode_updated_at && <div className="mt-1 text-[11px] text-slate-400" data-testid="admin-ad-mode-updated">Last changed {new Date(m.mode_updated_at).toLocaleString("en-IN")} by {m.mode_updated_by}</div>}
    </div>
  );
}
